import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  clearComponentByIdMultilingual,
  getComponentByIdMultilingual,
} from '@wajeez-web/stores/content';
import { useNavigate } from 'react-router-dom';
import { useGetComponentByIdMultilingual } from '@wajeez-web/components/helpers';

import { ComponentForm } from '../components/ComponentForm';

export const EditCollectionComponentsComponentPage = () => {
  const { pageId, componentId } = useParams<{
    pageId: string;
    componentId: string;
  }>();

  const navigate = useNavigate();

  const { data: componentDetailsMultilingualData } =
    useGetComponentByIdMultilingual();

  useEffect(() => {
    componentId && getComponentByIdMultilingual(componentId);

    return () => {
      clearComponentByIdMultilingual();
    };
  }, [componentId]);

  const basePathname = `/collection-components/${pageId}`;

  return (
    <div>
      <ComponentForm
        type="Edit"
        onSubmit={() => {
          navigate(basePathname);
        }}
        onItemTemplateCloneSaveAndEdit={(itemTemplateId) => {
          navigate(`${basePathname}/components/${itemTemplateId}/edit`);
        }}
        onItemTemplateEditButtonClick={(itemTemplateId) => {
          navigate(`${basePathname}/components/${itemTemplateId}/edit`);
        }}
        componentTypeId={componentDetailsMultilingualData?.typeId?.toString()}
        onCancel={() => {
          navigate(basePathname);
        }}
      />
    </div>
  );
};
